module.exports = __webpack_public_path__ + "static/media/contact_bg.e23d9124.jpg";